





























import Vue, { VNode } from "vue";
import axios from "axios";

export default Vue.extend({
  data() {
    return {
      list: []
    };
  },
  methods: {},
  computed: {
    weather_obj() {
      const weatherObj: object[] = this.$store.getters["weather/weather"];
      return weatherObj;
    },
    current() {
      const current: object = this.$store.getters["weather/current"];
      return current;
    }
  }
  // created() {

  // }
  // `createElement` is inferred, but `render` needs return type
  // render(createElement): VNode {
  //   return createElement("div", this.greeting);
  // }
});
